import * as React from "react";
import CurrencyFormat from "react-currency-format";
import { isNegative, valueAsNum } from "../../../utils/FormatHelpers";
/**
 *
 * @param props
 */
export var Currency = function (props) {
    if (props.amount === null || props.amount === undefined) {
        return null;
    }
    var amountAsNum = valueAsNum(props.amount);
    return (!!props.amount && isNegative(amountAsNum) ? (React.createElement(React.Fragment, null,
        React.createElement("span", { className: props.className }, "\u20AC\u00A0"),
        React.createElement(CurrencyFormat, { value: amountAsNum, thousandSeparator: ".", decimalSeparator: ",", displayType: !!props.isInput ? "input" : "text", className: props.className, decimalScale: props.withoutDecimal ? 0 : 2, fixedDecimalScale: true, onValueChange: props.onChange }))) : (React.createElement(CurrencyFormat, { value: amountAsNum, thousandSeparator: ".", decimalSeparator: ",", prefix: props.withoutPrefix ? "" : "€\xa0", displayType: !!props.isInput ? "input" : "text", className: props.className, decimalScale: props.withoutDecimal ? 0 : 2, fixedDecimalScale: true, onValueChange: props.onChange })));
};
